var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedCarMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 56",
    width: 23,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "red-car-map-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ca0303 } \n\t\t.s1 { fill: #ff0000 } \n\t\t.s2 { fill: #262a35 } \n\t\t.s3 { fill: #353f4b } \n\t\t.s4 { fill: #df2c3a } \n\t\t.s5 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m21.8 54.1c-2.5 2.1-7.5 2.2-10.1 2.2-2.6 0-7.6-0.1-10.1-2.2-2.6-2.1-1.6-33.5-1.6-41.9 0-6.1 0.4-8.2 1.8-9.7 1.5-1.5 7.4-2.6 9.9-2.6 2.5 0 8.4 1.1 9.9 2.6 1.4 1.5 1.8 3.9 1.8 9.7 0 8.4 1 39.8-1.6 41.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m21.8 18.7c-0.7 1.7-1.1 4.4-1.4 7.1 0.4 0.4 0.5 1.2 0.5 2.1 0.4 1.3 0.1 3.9 0 5.5 0 0.1 0 0.3 0 0.4 0 0 0.3 5.6 0 8 0 0.6-0.1 1.2-0.3 1.6 0 0.8 1 3.9 0.9 4.5-0.2 1.1-0.2 3.8-0.6 4-2.3 2-6.9 2-9.2 2-2.3 0-6.9 0-9.2-2-0.4-0.2-0.4-2.9-0.6-4-0.1-0.6 0.9-3.7 0.9-4.5-0.1-0.2-0.3-1-0.3-1.6-0.3-2.4 0-8 0-8 0-0.1 0-0.3 0-0.4-0.1-1.6-0.4-4.2 0-5.5 0-0.9 0.1-1.7 0.5-2.1-0.3-2.7-0.7-5.4-1.4-7.1-0.4-1.9-0.6-3.9-0.6-5.2 0-6.2 0.3-7.7 1.7-9.1 1.3-1.4 6.7-1.9 9-1.9 2.3 0 7.7 0.5 9 1.9 1.4 1.4 1.7 3.5 1.7 9.1 0 1.3-0.2 3.3-0.6 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m0.6 33.4c0-5.3 0-11.1 0.3-14.1l1.6 8.4v5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m2.5 33.8v8l-1.6 2.2c0 0-0.2-4.7-0.3-10.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m21.8 18.7l-1.4 7.1c0 0-2.3-2.1-8.7-2.1-6.4 0-8.7 2.1-8.7 2.1l-1.4-7.1c4.3-3.1 10.1-3 10.1-3 0 0 5.8-0.1 10.1 3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m20.9 33.4v-5.7l1.6-8.4c0.3 3 0.3 8.8 0.3 14.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m22.8 33.8c-0.1 5.5-0.3 10.2-0.3 10.2l-1.6-2.2v-8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m21.5 47.9c-1.5 0.9-4.6 2-9.8 2-5.2 0-8.3-1.1-9.8-2-0.2-1.8 0.9-4.5 0.9-4.5 2.1 0.6 15.7 0.6 17.8 0 0 0 1.1 2.7 0.9 4.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0.4 20.9l-2.4 0.6c-0.3 0-0.5-0.2-0.4-0.4 0-0.4 0.3-1.1 1.1-1.3 1.4-0.4 1.7 1.1 1.7 1.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m24.6 19.8c0.9 0.2 1.2 0.9 1.2 1.3 0.1 0.2-0.1 0.4-0.4 0.4l-2.4-0.6c0 0 0.3-1.5 1.6-1.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m11.7 23.7v-8c0 0 5.8-0.1 10.1 3l-1.4 7.1c0 0-2.3-2.1-8.7-2.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m21.5 47.9c-1.5 0.9-4.6 2-9.8 2v-6.1c3.5 0 7-0.1 8.5-0.3q0.1 0 0.1 0 0.1 0 0.1 0 0.1-0.1 0.2-0.1c0 0 1.1 2.7 0.9 4.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m14.6 56.2c-1.1 0.1-2.1 0.1-2.9 0.1-0.8 0-1.8 0-2.9-0.1 0-0.3 0.2-0.6 0.5-0.6q2.4 0.2 4.8 0c0.3 0 0.5 0.3 0.5 0.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m5.7 55.8c-1.1-0.2-2.1-0.5-2.9-0.9q0-0.1 0-0.1 0 0 0 0c0.1-0.3 0.3-0.4 0.6-0.3q1 0.3 2.1 0.6c0.2 0 0.4 0.3 0.3 0.5q0 0 0 0 0 0.2-0.1 0.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m20.6 54.8q0 0 0 0.1c-0.8 0.4-1.8 0.7-2.9 0.9q-0.1 0-0.1-0.2 0 0 0 0c-0.1-0.2 0.1-0.5 0.3-0.5q1.1-0.3 2.1-0.6c0.3-0.1 0.5 0 0.6 0.3q0 0 0 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m11.7 0.4c-1.9 0-3.8 0.4-5.6 0.8-0.3 0.1-0.6-0.1-0.7-0.4q0 0 0 0c0-0.1 0.1-0.3 0.2-0.3 2.2-0.6 4.7-0.9 6.1-0.9 1.4 0 3.9 0.3 6.1 0.9 0.1 0 0.2 0.2 0.2 0.3q0 0 0 0c-0.1 0.3-0.4 0.5-0.7 0.4-1.9-0.4-3.7-0.8-5.6-0.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m16.8 7.2l-0.8 5.2c-0.1 0.3-0.3 0.5-0.5 0.5h-7.6c-0.2 0-0.4-0.2-0.5-0.5l-0.8-5.2 1 4.7c0 0.2 0.3 0.4 0.5 0.4h7.2c0.2 0 0.5-0.2 0.5-0.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m2.2 2.2c0.6-0.4 1.5-0.8 2.7-1.2q0 0 0 0.1 0 0 0 0c0.1 0.2 0 0.4-0.2 0.5q-1.4 0.5-2.8 1.1 0.2-0.1 0.4-0.1-0.1-0.2-0.1-0.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1.7 2.7q0-0.1 0.1-0.2 0.2-0.2 0.4-0.3 0 0.2 0.1 0.4-0.2 0-0.4 0.1-0.1 0-0.2 0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m18.5 1c1.2 0.4 2.2 0.8 2.8 1.2q-0.1 0.2-0.2 0.4 0.2 0.1 0.3 0.2-1.3-0.7-2.7-1.3c-0.1-0.1-0.2-0.3-0.2-0.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m21.6 2.5q0.1 0.1 0.2 0.2-0.2 0.1-0.4 0.1-0.1-0.1-0.3-0.2 0.1-0.2 0.2-0.4 0.1 0.1 0.3 0.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m-0.1 32.4h-0.1c-0.1 0-0.2-0.1-0.2-0.2v-1.3c0-0.1 0.1-0.2 0.2-0.2h0.1c0.1 0 0.2 0.1 0.2 0.2v1.3c0 0.1-0.1 0.2-0.2 0.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m-0.1 36.9h-0.1c-0.1 0-0.2-0.1-0.2-0.2v-1.2c0-0.1 0.1-0.2 0.2-0.2h0.1c0.1 0 0.2 0.1 0.2 0.2v1.2c0 0.1-0.1 0.2-0.2 0.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m23.6 32.4h-0.1c-0.1 0-0.2-0.1-0.2-0.2v-1.3c0-0.1 0.1-0.2 0.2-0.2h0.1c0.1 0 0.2 0.1 0.2 0.2v1.3c0 0.1-0.1 0.2-0.2 0.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m23.6 36.9h-0.1c-0.1 0-0.2-0.1-0.2-0.2v-1.2c0-0.1 0.1-0.2 0.2-0.2h0.1c0.1 0 0.2 0.1 0.2 0.2v1.2c0 0.1-0.1 0.2-0.2 0.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCarMap);
export default __webpack_public_path__ + "static/media/red-car-map.fa32348a817b8cef2b59eff05a43995b.svg";
export { ForwardRef as ReactComponent };